import { Dispatch } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

// export type AppDispatch = typeof rootReducer.dispatch
export function useAppDispatch<TDispatch = Dispatch<any>>(): TDispatch{
    return useDispatch() as any;
  }